import router from "@/router";
import { LotInterface } from "@/types/LotInterface";

export const redirectIfBuilderIsDisabled = (lot: LotInterface): void => {
  if (lot.isBuildersEnabled) {
    return;
  }

  router.go(-1);
};
